<p-card class="w-full p-0 rounded-xl overflow-hidden h-full">

  <div class="flex mb-4 justify-center  items-center ">
    <img class="w-full rounded-t-xl" [src]="cardItem().icon" alt="">
  </div>
  <div class="py-4 pr-6 pl-3">
    <h3 class="mb-1 text-[#010128] font-bold text-lg">{{cardItem().name}}</h3>
    <h4 class="text-[#010128] font-[400] text-[16px]">{{cardItem().discrption}}</h4>
  </div>

</p-card>